import { _ } from "i18n";
import { Statistics } from "../../types";
import { TILES_COLORS, PORTAL_TILE_COLORS, DEFAULT_RETURN_VALUE, mathRound, DEFAULT_EMPTY_NUMBER_VALUE } from "../../utils";
import Quintiles from "../../static-data/quintiles_beta_version.json";

export function handlePageCount(totalRecords: number, currentPageSize: number): number {
	return totalRecords <= currentPageSize
		? 1
		: (totalRecords / currentPageSize) % 1 === 0
			? totalRecords / currentPageSize
			: Math.floor(totalRecords / currentPageSize) + 1;
}

export function getCellValue(total: number, success: number | undefined) {
	if (success?.toString() !== DEFAULT_RETURN_VALUE && success !== undefined && total?.toString() !== DEFAULT_RETURN_VALUE) {
		if (total === null || success === null) {
			return DEFAULT_EMPTY_NUMBER_VALUE;
		}

		return `${mathRound(success)}/${mathRound(total)}`;
	}
	if (total?.toString() !== DEFAULT_RETURN_VALUE) {
		if (total === null) {
			return DEFAULT_EMPTY_NUMBER_VALUE;
		}
		return `${mathRound(total)}`;
	}

	return DEFAULT_RETURN_VALUE;
}

export function getStrongFootTranslation(value: string) {
	if (value && value === "right") {
		return _("label.player.strongestFoot.right.letter");
	}
	if (value && value === "left") {
		return _("label.player.strongestFoot.left.letter");
	}
	return DEFAULT_RETURN_VALUE as string;
}

export function getGenderTranslation(value: string) {
	switch (value) {
		case "Male":
			return _("app.player.profile.gender.Male");
		case "Female":
			return _("app.player.profile.gender.Female");
		case "Mixed":
			return _("app.player.profile.gender.Mixed");
		default:
			return DEFAULT_RETURN_VALUE as string;
	}
}

export const getColor = (position: string, type: string, value: number, isPortal: boolean) => {
	const statistics = (Quintiles as Statistics).statistics[type];

	if (!Array.isArray(statistics) || statistics.length === 0) {
		return { background: "", color: "" };
	}
	if (value === undefined || value === null || typeof value !== "number" || Number.isNaN(value)) {
		return { background: "", color: "" };
	}

	const thresholds = statistics.filter((q) => q.position === position);
	if (thresholds.length === 0) {
		return { background: "", color: "" };
	}

	const colors = isPortal ? PORTAL_TILE_COLORS : TILES_COLORS;

	const g1 = { background: colors.green1.background, color: isPortal ? colors.green1.color : colors.grey.color };
	const g2 = { background: colors.green2.background, color: isPortal ? colors.green2.color : colors.grey.color };
	const gr = { background: colors.grey.background, color: isPortal ? colors.grey.color : colors.grey.color };
	const r4 = { background: colors.red4.background, color: isPortal ? colors.red4.color : colors.grey.color };
	const r5 = { background: colors.red5.background, color: isPortal ? colors.red5.color : colors.grey.color };

	// Find the highest percentile whose threshold is <= value
	const match = thresholds
		.slice()
		.sort((a, b) => b.value - a.value)
		.find((q) => value >= q.value);

	const percentile = match?.percentile ?? 0;
	const isZero = value === 0;

	switch (percentile) {
		case 80:
			return isZero ? gr : g1;
		case 60:
			return isZero ? gr : g2;
		case 40:
			return isZero ? r4 : gr;
		case 20:
			return isZero ? r5 : r4;
		default:
			return r5;
	}
};
